import { DataPlatformEventFilter } from 'app/data-platform/data-platform.model';

const DAY_MS = 24 * 60 * 60 * 1000;

export interface DayWindow {
  start: Date;
  end: Date;
}

export function startOfDay(date: Date): Date {
  const day = new Date(date);
  day.setHours(0, 0, 0, 0);
  return day;
}

export function endOfDay(date: Date): Date {
  const day = new Date(date);
  day.setHours(23, 59, 59, 999);
  return day;
}

/** Calendar days, so a daylight saving switch keeps the time of day. */
export function shiftDays(date: Date, days: number): Date {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + days);
  return shifted;
}

/** Rounded, so a daylight saving hour never loses a day. */
export function daysBetween(from: Date, to: Date): number {
  return Math.round((startOfDay(to).getTime() - startOfDay(from).getTime()) / DAY_MS);
}

/** The local date as `YYYY-MM-DD`. */
export function dayKey(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function yearLabel(window: DayWindow, yearsBack = 0): string {
  const first = window.start.getFullYear() - yearsBack;
  const last = window.end.getFullYear() - yearsBack;
  return first === last ? String(last) : `${first}/${String(last).slice(-2)}`;
}

/** The Sunday that starts the API's week bucket for a `YYYY-MM-DD` day, as `YYYY-MM-DD`. */
export function weekStart(day: string): string {
  const date = new Date(`${day}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() - date.getUTCDay());
  return date.toISOString().slice(0, 10);
}

/** The API filters and buckets by whole UTC days. */
export function wholeDays(window: DayWindow): Pick<DataPlatformEventFilter, 'from' | 'to'> {
  return { from: `${dayKey(window.start)}T00:00:00.000Z`, to: `${dayKey(window.end)}T23:59:59.999Z` };
}
